import React, {Component} from "react";

class UnderMaintainance extends Component {

    redirectToHome = () => {
        const path = localStorage.getItem('Islogin') && localStorage.getItem('Islogin') === 'true' ? 'myaccount' : '/'
        this.props.router.push(path)
    }

    componentDidMount() {
        document.title = "Under maintenance";
    }

    render() {
        return (
            <section className="top-inner animatedParent main-content-height mb-5">
                {/* <div className="container"> */}
                <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
        <div className="text-center p-4">
          <img
            src="/images/under-construction.svg"
            alt="Under Maintenance"
            className="mb-4 w-250"
          />
          <h1 className="display-4">We'll be back soon!</h1>
          <p className="lead mb-4">
            Sorry for the inconvenience. We're performing some maintenance at the moment. We'll be back online shortly!
          </p>
          <p className="text-muted">— The Team</p>
        </div>
                </div>
            </section>

        )
    }
}

export default UnderMaintainance;